import React from 'react';
import { LinearProgress } from '@mui/material';
import { COLORS } from '../settings/variables/Colors';
import { SPACERS } from '../settings/variables/Spacers';

interface TrueImpactPageLoadingProps {
  show: boolean;
}

const styles: React.CSSProperties = {
  top: 0,
  left: 0,
  right: 0,
  zIndex: 999,
  position: 'fixed',
  height: SPACERS.tiny,
  backgroundColor: COLORS.ctaPrimaryBackground,
};

const TrueImpactPageLoading: React.FC<TrueImpactPageLoadingProps> = ({
  show,
}) => {
  if (!show) return null;
  return <LinearProgress variant="query" style={styles} />;
};

export default TrueImpactPageLoading;
